import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OnlyNumberDirective} from "./only-number.directive";
import {TwoDecimalPlaceDirective} from "./two-decimal-place.directive";
import {NoDecimalDirective} from "./no-decimal.directive";
import {NoStartingZeroDirective} from "./no-starting-zero.directive";
import {AusPhoneFormatDirective} from "./aus-phone-format.directive";
import { AccessPermissionsDirective } from './access-permissions.directive';
import { DisabledGroupDirective } from './disabled-group.directive';
import {CapitalizeFirstLetterDirective} from './capitalize-first-letter.directive';
import {TrimFirstLastSpaceDirective} from './trim-first-last-space.directive';
import {LimitInputLengthDirective} from './limit-input-length.directive';
import {UppercaseDirective} from './upper-case.directive';
import {AutofocusDirective} from './auto-focus.directive';
import {CurrencyDecimalDirective} from "./currency-decimal.directive";

const directives = [
  NoDecimalDirective,
  OnlyNumberDirective,
  TwoDecimalPlaceDirective,
  NoStartingZeroDirective,
  AusPhoneFormatDirective,
  AccessPermissionsDirective,
  DisabledGroupDirective,
  CapitalizeFirstLetterDirective,
  TrimFirstLastSpaceDirective,
  LimitInputLengthDirective,
  UppercaseDirective,
  AutofocusDirective,
  CurrencyDecimalDirective,
];

@NgModule({
    imports: [
        CommonModule,
        ...directives
    ],
    exports: directives
})

export class SharedDirectivesModule {
}
